/**
 * Checks if an alert is recent (less than 96 hours old) based on epoch_initiation
 * @param {Object} alert - The alert object with epoch_initiation field
 * @returns {boolean} - True if alert is less than 96 hours old, false otherwise
 */
const isRecentAlert = (alert) => {
  if (!alert || !alert.epoch_initiation) {
    return false;
  }

  // epoch_initiation is in seconds (bigint)
  const alertEpoch = typeof alert.epoch_initiation === 'number' 
    ? alert.epoch_initiation 
    : parseInt(alert.epoch_initiation, 10);

  if (isNaN(alertEpoch) || alertEpoch <= 0) {
    return false;
  }

  // Current time in seconds
  const currentEpoch = Math.floor(Date.now() / 1000);
  
  // 96 hours in seconds = 96 * 60 * 60 = 345600
  const hours96InSeconds = 96 * 60 * 60;
  
  // Check if alert is less than 96 hours old
  const ageInSeconds = currentEpoch - alertEpoch;
  return ageInSeconds < hours96InSeconds;
};

export default isRecentAlert;

